import script from "./ExternalModule.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalModule.vue?vue&type=script&setup=true&lang=js"

import "./ExternalModule.vue?vue&type=style&index=0&id=6cd21a09&lang=scss"

const __exports__ = script;

export default __exports__